import FilterSearchBox from "./FilterSearchBox";
export default FilterSearchBox;